export class BaseStorage {
    static verify(strategy) {
        if (strategy instanceof BaseStorage) {
            return strategy;
        }
        else {
            throw new Error('This class must extend BaseStorage!');
        }
    }
    extendScope(scope) {
        return scope;
    }
}
//# sourceMappingURL=base-storage.js.map